// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personCard {
  height: 180px;
  border: 2px solid #E2E2E2;
  margin: auto;
  cursor: pointer;
  border-radius: 3px;
}

.cardSelected {
  background: #5BC8AC; /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(#5BC8AC, white); /* Standard syntax */
}

.cardNotSelected {
  background-image: url('backgroundCard.png');
}

.personCardEvaluations {
  margin-top: 11px;
  width: 100%;
}

.personCardEvaluationsMPO {
  width: 33%;
}

.personCardEvaluationsIDW {
  width: 34%;
}

.personCardEvaluationsCompetence {
  width: 33%;
}

.cardEvaluationTitle {
  margin-top: -5px;
  color: #111111;
  padding-top: 0;
  text-align: center;
}

.ngOrangeBorder {
  border: 2px solid #5BC8AC;
}

div.splitInTwo, div.splitInFive {
  width: 100%;
}

div.splitInTwo > div {
  width: 50%;
  margin: auto;
  float: left;
}

.chipTwo {
  width: -moz-fit-content;
  width: fit-content;
  margin: auto;
}

div.splitInFive div > div.indChip {
  width: 19%;
}

.chipContainer {
  width: 100%;
  margin: auto;
}

.chip {
  margin: auto;
}

div.indChip {
  position: absolute;
}

div.mpo {
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/graphics/people-card/people-card.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAGA;EACI,mBAAA,EAAA,+CAAA,EACA,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,2CAAA,EAAA,oBAAA;AAAJ;;AAGA;EACI,2CAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAAJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,uBAAA;EAAA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;AADF","sourcesContent":[".personCard {\n    height: 180px;\n    border: 2px solid #E2E2E2;\n    margin: auto;\n    cursor: pointer;\n    border-radius: 3px;\n\n}\n\n.cardSelected {\n    background: #5BC8AC; /* For browsers that do not support gradients */\n    background: -webkit-linear-gradient(#5BC8AC, white); /* For Safari 5.1 to 6.0 */\n    background: -o-linear-gradient(#5BC8AC, white); /* For Opera 11.1 to 12.0 */\n    background: -moz-linear-gradient(#5BC8AC, white); /* For Firefox 3.6 to 15 */\n    background: linear-gradient(#5BC8AC, white); /* Standard syntax */\n}\n\n.cardNotSelected {\n    background-image: url('../../../../assets/backgroundCard.png');\n}\n\n.personCardEvaluations {\n    margin-top: 11px;\n    width: 100%;\n}\n\n.personCardEvaluationsMPO {\n    width: 33%\n}\n\n.personCardEvaluationsIDW {\n    width: 34%\n}\n\n.personCardEvaluationsCompetence {\n    width: 33%;\n}\n\n.cardEvaluationTitle {\n    margin-top: -5px;\n    color: #111111;\n    padding-top: 0;\n    text-align: center\n}\n\n\n.ngOrangeBorder {\n    border: 2px solid #5BC8AC;\n}\n\ndiv.splitInTwo, div.splitInFive {\n  width: 100%;\n}\n\ndiv.splitInTwo > div {\n  width: 50%;\n  margin: auto;\n  float: left;\n}\n\n.chipTwo {\n  width: fit-content;\n  margin: auto;\n}\n\ndiv.splitInFive div > div.indChip {\n  width: calc(95% /5);\n}\n\n.chipContainer {\n  width: 100%;\n  margin: auto;\n}\n\n.chip {\n  margin: auto;\n}\n\ndiv.indChip {\n  position: absolute;\n}\n\ndiv.mpo {\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
